<template>
  <div v-if="data">
    <div @click="showDialog" class="tac-ruleDialog">{{ $root.getText('tc') }}</div>
    <van-dialog
      className="ruleDialog-dialog"
      v-model="visplayDialog"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <div @click="closeDialog" class="ruleDialog-close">
        <img src="../images/smg.png">
      </div>
      <div class="ruleDialog-content">
        <div class="ruleDialog-title">{{ $root.getText('tcTitle') }}</div>
        <div class="ruleDialog-info">
          <div class="w-f flex-icenter p-0-16 mb-8">
            <span class="ruleDialog-label">{{ $root.getText('tcTime') }}</span>
            <span class="ruleDialog-text">{{ data.beginTime }} - {{ data.endTime }}</span>
          </div>

          <div class="w-f flex-icenter p-0-16 mb-8">
            <span class="ruleDialog-label">{{ $root.getText('tcActiveObject') }}</span>
            <span class="ruleDialog-text">{{ $root.getText('tcObject') }}</span>
          </div>

          <div class="w-f p-0-16 mb-8">
            <div class="ruleDialog-label mb-8">{{ $root.getText('tcActiveContent') }}</div>
            <div class="ruleDialog-text" v-html="description"></div>
          </div>

        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Dialog from 'vant/lib/dialog/index'
import 'vant/lib/dialog/style/index'

Vue.use(Dialog.Component);

export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      visplayDialog:  false
    }
  },
  computed: {
    description() {
      if (this.data && this.data.description) {
        return String(this.data.description).replace(/\n/g, '<br />')
      }
      return ''
    }
  },
  methods: {
    showDialog() {
      this.visplayDialog = true
    },
    closeDialog() {
      this.visplayDialog = false
    }
  }
}
</script>

<style lang="stylus">
.tac-ruleDialog {
  position: absolute;
  top: 41px;
  right: 0;
  display: flex;
  padding: 0 10px;
  align-items: center;
  justify-content: flex-end;
  min-width: 56px;
  height: 24px;
  background: #FFFFFF;
  font-weight: 600;
  font-size: 11px;
  color: #FC2040;
  z-index: 10;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  &:active {
    filter: brightness(0.9);
  }
}

.ruleDialog-dialog{
  width: 335px;
  background: #FFFFFF;
  border-radius: 8px;
}
.ruleDialog-content{
  padding-bottom: 18px;
  width: 335px;
  .ruleDialog-title{
    padding: 20px 16px;
    font-weight: bold;
    font-size: 18px;
    color: #1E1E1E;
  }
  .ruleDialog-info{
    width: 100%;
    max-height: 60vh;
    overflow-y: auto;
  }
  .ruleDialog-label{
    margin-right: 10px;
    font-weight: 500;
    font-size: 14px;
    color: #1E1E1E;
    white-space: nowrap;
  }
  .ruleDialog-text{
    line-height: 20px;
    font-weight: 400;
    font-size: 12px;
    color: #909090;
  }
}
.w-f{
  width: 100%;
}
.mb-8{
  margin-bottom: 8px;
}
.p-0-16{
  padding: 0 16px;
}
.flex-icenter{
  display: flex;
  align-items: center;
}

.ruleDialog-close{
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  img{
    width: 16px;
    height: 16px;
  }
  &:active {
    opacity: 0.8;
  }
}
</style>
